import React from 'react';

function SubcontractingServicesDetails() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-6">
      <h1 className="text-4xl font-bold mb-8 text-center">Subcontracting Services UK</h1>
      <div className="bg-gray-900 p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-200">
        <h2 className="text-3xl font-semibold mb-4 text-white">Overview</h2>
        <p className="text-white mb-4">
          Crown Defence Security also provides subcontracting services for other security companies in the UK. We partner with security firms to deliver high-quality services, ensuring the safety and security of their clients through our expertise and resources.
        </p>
        <h2 className="text-2xl font-semibold mb-4 text-white">Services We Offer</h2>
        <ul className="list-disc list-inside text-white space-y-2">
          <li>Temporary Security Staffing</li>
          <li>Event Security Support</li>
          <li>Construction Site Security</li>
          <li>Mobile Patrol Services</li>
          <li>Alarm Response Services</li>
          <li>Specialized Security Tasks</li>
        </ul>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Why Choose Us?</h2>
        <p className="text-white mb-4">
          Our team at Crown Defence Security is dedicated to providing reliable and efficient subcontracting services. We bring our extensive experience and adhere to strict industry standards, ensuring that our partner companies receive the best possible support.
        </p>
        <h2 className="text-2xl font-semibold mt-8 mb-4 text-white">Contact Us</h2>
        <p className="text-white">
          For more information about our subcontracting services in the UK, please contact us at <a href="tel:07460395006" className="text-yellow-500 hover:underline">0746 039 5006</a> or email us at <a href="mailto:info@crowndefencesecurity.co.uk" className="text-yellow-500 hover:underline">info@crowndefencesecurity.co.uk</a>.
        </p>
      </div>
    </div>
  );
}

export default SubcontractingServicesDetails;
